import React from "react";
import Navbar from "../navbar";
import FewClick from "./fewClick";
import Questions from "./questions";
import Footer from "../footer";

function home() {
  return (
    <div className="main_container">
      <div className="marginApp">
        <Navbar />
        <FewClick />
      </div>

      <Questions />
      <Footer />
    </div>
  );
}

export default home;
